
import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import highResDesktopImageWebp from './images/tax-documents-hero-desktop.webp';
import highResMobileImageWebp from './images/tax-documents-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='tax-documents-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Tax resource center'
      headingText={<>Let&#39;s get you prepared for <WidowBlock>tax season.</WidowBlock></>}
      descriptionText={<>Find the information and tax documents you&#39;ll need to file your taxes.</>}
      ctaPrimary={{
        linkUrl: 'https://plan.northwesternmutual.com/documents/',
        buttonText: 'Get your tax forms',
        ariaLabel: 'Get insurance with a financial professional.',
        children: '',
        isOutgoingLink: true,
      }}
      backgroundImageAriaLabel='a married couple going over their tax documents together'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );};
